import React from "react";
import Navbar from "../dashboard/Navbar";
import { Grid } from "@mui/material";
import LeftBar from "../dashboard/LeftBar";
import { isMobile } from 'react-device-detect';
import AutoJiraList from "./autoJiraList";

const AutoJiraTicketView = () => {
    
    const defaultPage = [0, 0, 1, 0]
    return (
        <div>
            <Navbar />
            <Grid container>
                {!isMobile && (
                    <Grid item>
                        <LeftBar page={defaultPage} />
                    </Grid>
                )}
                <Grid item >
                    <AutoJiraList />
                </Grid>
            </Grid>
        </div>
    );
};

export default AutoJiraTicketView;